import constants from './constants';

const initialState = {
    url: '',
    isHostCancel: false,
    isAttendeeCancel: false,
    eventName: '',
    isError: false,
    error: null,
    isMailError: false
};

export default (state = initialState, action) => {
    
    switch (action.type) {
       
        case constants.REDIRECT_TO:
            
            if (action.data.isError === true) {
                return { ...state, url: action.data.url, error: action.data.result.response.data.error, isMailError : (action.data.result.response.data.error === "mail-error" ? true : false) }
            }
            else {
                if (action.data.isHostCancel === true) {
                    return { ...state, url: action.data.url, isHostCancel: action.data.isHostCancel, isAttendeeCancel: false, eventName: action.data.eventName }
                }
                else if (action.data.isAttendeeCancel === true) {
                    return { ...state, url: action.data.url, isHostCancel: false, isAttendeeCancel: action.data.isAttendeeCancel, eventName: action.data.eventName }
                }
                else {
                    return { ...state, url: action.data.url }
                }
            }
        default:
            return state;
    }
}